import { IntlShape, MessageDescriptor } from 'react-intl';
import { ServiceRow, ServiceRowAction } from './servicesPanelRows';
import { servicesPanelMessages as m } from './servicesPanelMessages';
import { shownLink } from './serviceLinkEdit';

export const ACTION_LABELS: Record<ServiceRowAction, MessageDescriptor> = {
  open: m.open,
  edit: m.edit,
  paste: m.paste,
  findIt: m.findIt,
};

/** The second line of the row. */
export function lineText(intl: IntlShape, row: ServiceRow): string {
  if (row.line === 'link') {
    return row.url === null ? '' : shownLink(row.url);
  }
  return intl.formatMessage(m.notLinked);
}
